import { render } from "./Marketplaces.vue?vue&type=template&id=47ba5745"
import script from "./Marketplaces.vue?vue&type=script&lang=js"
export * from "./Marketplaces.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/intelli-landing-frontend/intelli-landing-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__